import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useState } from "react";
import ReactLoading from 'react-loading';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import Pagination from '@material-ui/lab/Pagination';
import DatePicker from "react-datepicker";

// css
import '../../common.css';
import './daily-sales-report.css';

// components
import Navbar from '../../navbar';
import TableTemplate from '../../table-template';

// sample data (temp)
import { getAllBranches } from "../../../utilities/api_calls/branchApi";
import { getAllItems } from "../../../utilities/api_calls/inventoryApi";
import { getProductsRenderedList } from "../../../utilities/api_calls/reports/dailyProductsPurchasedApi";
import { getTodayDate, getTodayDateISO } from "../../../utilities/common";
import { Button } from 'react-bootstrap';
import NoDataPrompt from '../../../utilities/no-data-prompt';

function DailyProductsPurchasedReportAll() {
  const [showLoader, setShowLoader] = useState(true);
  const [dailyProducts, setDailyProducts] = useState([]);
  const [totals, setTotals] = useState({});
  const { id } = useParams();

  //All items
  const [items, setItems] = useState([]);

  // Pagination
  const [pages, setPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  function handlePageChange(event, value) {
    setCurrentPage(value)
  }

  //Get Items
  async function fetchItems() {
    const response = await getAllItems();
    var allItems = response.data.data.items
    setItems(response.data.data.items);

    // set Options
    setItemOptions([]);
    var all = { name: "All Items", id: "" };
    setItemOptions(prevState => [...prevState, all]);

    allItems.map((data) => {
      var info = {};

      info.name = data.name;
      info.id = data.id;

      setItemOptions(prevState => [...prevState, info]);
    })
  }

  // select Items
  const [clear, setClear] = useState(true);
  const [itemOptions, setItemOptions] = useState([]);
  const [value, setValue] = useState({})

  const handleFilterItems = (e) => {
    setClear(false)
    setFilter(prevState => ({
      ...prevState,
      ['item']: e.value
    }));
    setValue({ label: e.label, value: e.value })
  }

  const options = itemOptions.map((emp) => (
    {
      label: emp.name,
      value: emp.id,
    }
  ))

  //Filter
  const [filter, setFilter] = useState({
    branch: id,
    item: "",
    date_from: getTodayDate(),
    date_to: getTodayDate(),
    search: ''
  });

  // -- Filter Functions --- //
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter(prevState => ({
      ...prevState,
      [name]: value
    }));
  }

  const handleDateFromChange = (date) => {
    setFilter(prevState => ({
      ...prevState,
      ['date_from']: date
    }))
  }

  const handleDateToChange = (date) => {
    setFilter(prevState => ({
      ...prevState,
      ['date_to']: date
    }))
  }

  function removeFilter() {
    setFilter({
      branch: "",
      item: "",
      date_from: "",
      date_to: "",
      search: ""
    })
    setClear(true)
    fetchProductsRenderedList();
  }

  const [branches, setBranches] = useState([]);
  //Get all branches
  async function fetchBranches() {
    const response = await getAllBranches();
    setBranches(response.data.data.branches);
  }

  //Get Daily Products Rendered
  async function fetchProductsRenderedList() {
    setShowLoader(true);
    setTimeout(() => setShowLoader(false), 1000)
    setDailyProducts([]);
    const response = await getProductsRenderedList(filter);
    setPages(Math.ceil(response.data.data.sales.length / 9));
    setDailyProducts(response.data.data.sales.sort(function (a, b) { return new Date(b.DATE) - new Date(a.DATE); }));
    setTotals({
      grand_total: response.data.data.grand_total[0].grand_total,
      total_quantity: response.data.data.total_quantity[0].total_quantity,
    })
  }

  React.useEffect(() => {
    fetchProductsRenderedList();
    // eslint-disable-next-line
  }, [filter]);

  React.useEffect(() => {
    fetchProductsRenderedList();
    fetchBranches();
    fetchItems();
    // eslint-disable-next-line
  }, []);

  function renderTable() {
    if (dailyProducts.length === 0) {
      return (
        <NoDataPrompt text="products purchased" />
        // <span className="no-data-prompt">No Products Purchased found!</span>
      )
    } else {
      return (
        <>
          <TableTemplate
            tableType='sample_daily_products_purchased_report'
            tableHeaders={["Date", "Branch", "Customer", "Product", "Quantity", "Grand Total", "Derm Tech"]}
            tableData={dailyProducts}
            hasFooter={true}
            footerData={totals}
            currentPage={currentPage}
          />
          <Pagination count={pages} page={currentPage} shape="rounded" defaultPage={1} siblingCount={2} onChange={handlePageChange} showFirstButton showLastButton />
        </>
      )
    }
  }

  function handleShowData() {
    setTimeout(() => setShowLoader(false), 5000);
  }

  return (
    <>
      <div>
        <Navbar />
        <div className="active-cont">
          <Fragment>

            <div className="d-flex flex-row justify-content-between align-items-center cont-section">
              <h1 className="cont-sect-header">Daily Products Sales</h1>
              <div className="search-wrapper w-50">
                <input type="search" class="form-control search-indent" name="search" value={filter.search} onChange={(e) => handleFilterChange(e)} placeholder="Search by Customer Name" />
                <div className="search-icon">
                  <FontAwesomeIcon
                    className="icon"
                    icon={'search'}
                    aria-hidden="true"
                    alt={'search'}
                    fixedWidth
                  />
                </div>
              </div>
            </div>

            {/** FILTER */}
            <div className="filter-cont mt-0">
              <div className="filter-label-row1">FILTER BY:
                <select className="filter-dropdown-input" name="branch" value={filter.branch} onChange={(e) => handleFilterChange(e)}>
                  <option selected value="">All Branches</option>
                  {
                    branches.map((branch) => {
                      return (<option key={branch.id} value={branch.id}>{branch.name}</option>)
                    })}
                </select>
                <Select className="react-select-container" classNamePrefix="react-select" value={clear ? options[0] : value} placeholder="Select Item..." options={options} onChange={(e) => handleFilterItems(e)} />
                {/* <select className="filter-dropdown-input" name="item" value={filter.item} onChange={(e) => handleFilterChange(e)}>
                  <option selected hidden value="" disabled>--ITEM--</option>
                  <option value="">All Items</option>
                  {
                    items.map((branch) => {
                      return (<option key={branch.id} value={branch.id}>{branch.name}</option>)
                    })}
                </select> */}
              </div>
              <div className='filter-label-row1'>
                DATE FROM:
                <DatePicker selected={filter.date_from} dateFormat="MM/dd/yyyy" className="filter-date-picker mx-3 px-1" name="date_from" placeholderText="mm/dd/yyyy" onChange={date => handleDateFromChange(date)} />
                {/* <input type="date" className="filter-date-picker" name="date_from" value={filter.date_from} onChange={(e) => handleFilterChange(e)} /> */}
                
                TO:
                <DatePicker selected={filter.date_to} dateFormat="MM/dd/yyyy" className="filter-date-picker mx-3 px-1" name="date_to" placeholderText="mm/dd/yyyy" onChange={date => handleDateToChange(date)} />
                {/* <input type="date" className="filter-date-picker" name="date_to" value={filter.date_to} onChange={(e) => handleFilterChange(e)} /> */}
                
                <div className="btn-conf-wrapper in-line  remove-filter-btn">
                  <Button type="button" className="px-2 py-1 mtn-1" onClick={() => removeFilter()}>Remove Filter</Button>
                </div>
              </div>
            </div>

            <div className="cont-section-novertpad daily-products-table">
              {showLoader ? <>
                <ReactLoading type="spinningBubbles" color="#d4271c" height={200} width={100} className='list-loader' />
                {handleShowData()}</> : renderTable()}
            </div>

          </Fragment>

        </div>
      </div>
    </>
  );
}

export default DailyProductsPurchasedReportAll;